import { render } from "./AddStreamModal.vue?vue&type=template&id=035e7c1c&scoped=true"
import script from "./AddStreamModal.vue?vue&type=script&lang=js"
export * from "./AddStreamModal.vue?vue&type=script&lang=js"

import "./AddStreamModal.vue?vue&type=style&index=0&id=035e7c1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035e7c1c"]])

export default __exports__